<nav class="navbar navbar-default navbar-static-top" role="navigation" style="margin-bottom: 0">
    <div class="navbar-header">
        <button type="button" class="navbar-toggle" (click)="changeMenu()">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </button>
        <a class="navbar-brand" routerLink="/admin">{{titleName}}</a>    
        <!-- <span *ngIf="user" class="navbar-info">ID: {{user.staffCode}}</span>
        <span *ngIf="user" class="navbar-info">氏名: {{user.nickname}}</span>
        <span *ngIf="user && this.showUpdatePasswordTime" class="navbar-info">パスワード変更まで{{user.updatePasswordTime}}日</span> -->

    </div>
    <!-- /.navbar-header -->
  
    <ul class="nav navbar-top-links navbar-right">
      <!-- <li class="dropdown" dropdown>
        <a class="dropdown-toggle" dropdownToggle href (click)="false">
            {{langText}} <i class="fa fa-caret-down"></i>
        </a>
        <ul *dropdownMenu class="dropdown-menu dropdown-user">
          <li> <a (click)="setLocale('zh')">中文</a></li>
          <li> <a (click)="setLocale('en')">ENGLISH</a></li>
          <li> <a (click)="setLocale('jp')">日本語</a></li>
        </ul>
      </li> -->
        <!-- <li class="dropdown" dropdown>
            <a class="dropdown-toggle" dropdownToggle href (click)="false">
                <i class="fa fa-envelope fa-fw"></i> <i class="fa fa-caret-down"></i>
            </a>
            <ul *dropdownMenu class="dropdown-menu dropdown-messages">
                <li>
                    <a href="#">
                        <div>
                            <strong>John Smith</strong>
                            <span class="pull-right text-muted">
                                <em>Yesterday</em>
                            </span>
                        </div>
                        <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend...</div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="#">
                        <div>
                            <strong>John Smith</strong>
                            <span class="pull-right text-muted">
                                <em>Yesterday</em>
                            </span>
                        </div>
                        <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend...</div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="#">
                        <div>
                            <strong>John Smith</strong>
                            <span class="pull-right text-muted">
                                <em>Yesterday</em>
                            </span>
                        </div>
                        <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend...</div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a class="text-center" href="#">
                        <strong>Read All Messages</strong>
                        <i class="fa fa-angle-right"></i>
                    </a>
                </li>
            </ul>
        </li> -->
        <!-- /.dropdown -->
        <!-- <li class="dropdown" dropdown>
            <a class="dropdown-toggle" dropdownToggle href (click)="false">
                <i class="fa fa-tasks fa-fw"></i> <i class="fa fa-caret-down"></i>
            </a>
            <ul *dropdownMenu class="dropdown-menu dropdown-tasks">
                <li>
                    <a href="#">
                        <div>
                            <p>
                                <strong>Task 1</strong>
                                <span class="pull-right text-muted">40% Complete</span>
                            </p>
                            <div class="progress progress-striped active">
                                <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">
                                    <span class="sr-only">40% Complete (success)</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="#">
                        <div>
                            <p>
                                <strong>Task 2</strong>
                                <span class="pull-right text-muted">20% Complete</span>
                            </p>
                            <div class="progress progress-striped active">
                                <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">
                                    <span class="sr-only">20% Complete</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="#">
                        <div>
                            <p>
                                <strong>Task 3</strong>
                                <span class="pull-right text-muted">60% Complete</span>
                            </p>
                            <div class="progress progress-striped active">
                                <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">
                                    <span class="sr-only">60% Complete (warning)</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="#">
                        <div>
                            <p>
                                <strong>Task 4</strong>
                                <span class="pull-right text-muted">80% Complete</span>
                            </p>
                            <div class="progress progress-striped active">
                                <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">
                                    <span class="sr-only">80% Complete (danger)</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a class="text-center" href="#">
                        <strong>See All Tasks</strong>
                        <i class="fa fa-angle-right"></i>
                    </a>
                </li>
            </ul>
        </li> -->
        <!-- /.dropdown -->
        <!-- <li class="dropdown" dropdown>
            <a class="dropdown-toggle" dropdownToggle href (click)="false">
                <i class="fa fa-bell fa-fw"></i> <i class="fa fa-caret-down"></i>
            </a>
            <ul *dropdownMenu class="dropdown-menu dropdown-alerts">
                <li>
                    <a href="#">
                        <div>
                            <i class="fa fa-comment fa-fw"></i> New Comment
                            <span class="pull-right text-muted small">4 minutes ago</span>
                        </div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="#">
                        <div>
                            <i class="fa fa-twitter fa-fw"></i> 3 New Followers
                            <span class="pull-right text-muted small">12 minutes ago</span>
                        </div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="#">
                        <div>
                            <i class="fa fa-envelope fa-fw"></i> Message Sent
                            <span class="pull-right text-muted small">4 minutes ago</span>
                        </div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="#">
                        <div>
                            <i class="fa fa-tasks fa-fw"></i> New Task
                            <span class="pull-right text-muted small">4 minutes ago</span>
                        </div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a href="#">
                        <div>
                            <i class="fa fa-upload fa-fw"></i> Server Rebooted
                            <span class="pull-right text-muted small">4 minutes ago</span>
                        </div>
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a class="text-center" href="#">
                        <strong>See All Alerts</strong>
                        <i class="fa fa-angle-right"></i>
                    </a>
                </li>
            </ul>
        </li> -->
        <!-- /.dropdown -->
         <button type="button" style="padding: 3px 5px 3px 5px;">事業再構築</button>
        <li dropdown class="dropdown">
            <a class="dropdown-toggle" dropdownToggle href (click)="false">
                <i class="fa fa-user fa-fw"></i> <i class="fa fa-caret-down"></i>
            </a>
              <ul class="dropdown-menu dropdown-user" *ngIf="user">
                  <!-- <li>
                    <a href="javascript:;"><img src="{{user.avatar}}"  style="width:100px;height:100px;border:1px solid;border-radius:100%;"></a>
                  </li> -->
                  <li>
                    <a href="javascript:;"><div><i class="fa fa-user fa-fw"></i> {{user.nickname}}</div></a>
                  </li>
                  <li>
                    <a href="javascript:;"><div><i class="fa fa-mobile fa-fw"></i> {{user.phone}}</div></a>
                  </li>
                  <li>
                    <a href="#" [routerLink]="['/admin/auth/user', user.id]"><i class="fa fa-gear fa-fw"></i> Settings</a>
                  </li>
                  <li>
                    <a href="#" [routerLink]="['/admin/password']"><i class="fa fa-wrench fa-fw"></i> パスワード変更</a>
                  </li>
                  <li class="divider"></li>
                  <li>
                    <a (click)="logout()" style="cursor: pointer;"><i class="fa fa-sign-out fa-fw"></i> Logout</a>
                  </li>
              </ul>
            <!-- /.dropdown-user -->
        </li>
        <!-- /.dropdown -->
    </ul>
    <!-- /.navbar-top-links -->
  
    <div class="navbar-default sidebar" role="navigation" [hidden]="isHide">
        <div class="sidebar-nav navbar-collapse">
            <ul class="nav" id="side-menu">
                <!-- <li class="sidebar-search">
                    <div class="input-group custom-search-form">
                        <input type="text" class="form-control" placeholder="Search...">
                        <span class="input-group-btn">
                        <button class="btn btn-default" type="button">
                            <i class="fa fa-search"></i>
                        </button>
                    </span>
                    </div>
                </li> -->
                <li *ngFor="let nav of navs">
                    <a [routerLink]="nav.path" style="color: black"  *ngIf="nav.path"><i class="fa fa-fw" [ngClass]="nav.icon"></i> {{  nav.name }}
                        <div style="font-size: 12px;margin-left: 20px;" *ngIf="nav.path == '/admin/shop/order'">注文単位での管理機能です。</div>
                    </a>
                    <!-- <span class="fa arrow"></span> -->
                    <!-- <span class="fa fa-angle-left pull-right"></span> -->
                    <a *ngIf="nav.children" href="javascript:;" (click)="childrenShow(nav)" style="color: black"><i class="fa fa-fw" [ngClass]="nav.icon"></i>
                       {{ lang == 'zh' ? nav.name : lang == 'en' ? nav.name : nav.nameJp}}
                       <span [ngClass]="{ 'fa fa-angle-left pull-right' : nav.isActive, 'fa fa-angle-down pull-right': !nav.isActive}"></span> </a>
                    <div class=""  [hidden]="nav.isHidden" >
                      <ul class="nav nav-second-level">
                        <li *ngFor="let nv of nav.children"><a [routerLink]="nv.path">{{ lang == 'zh' ? nv.name : lang == 'en' ? nv.name : nv.nameJp}}</a></li>
                      </ul>
                    </div>
                </li>
  
  
            </ul>
        </div>
        <!-- /.sidebar-collapse -->
    </div>
    <!-- /.navbar-static-side -->
  </nav>
  
  
  <div id="page-wrapper">
  <router-outlet></router-outlet>
  </div>

